import Vue from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

Vue.component('in-page-navigation-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            allNavigationItems: [],
            allNavItems: null,
            selected: null,
            currentIndex: null,
            navIsBlack: false,
            pastLastSection: false,
            prevActive: null,
            activeTimer: null,
        };
    },

    watch: {},

    computed: {},

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        gsap.registerPlugin(ScrollTrigger);
        this.allNavigationItems = document.querySelectorAll('[data-page-nav]');
        this.allNavItems = this.initPageNav();
        this.detectSection();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        handleSetTitleClasses(navItem) {
            return navItem.iconUrl.length
                ? 'france-in-page-navigation__item-title'
                : 'france-in-page-navigation__item-title--no-image';
        },

        uppercaseItemTitle(itemTitle) {
            return itemTitle.toUpperCase();
        },

        initPageNav() {
            if (!this.allNavigationItems) {
                return;
            }

            const arr = [];
            for (const element of this.allNavigationItems) {
                const obj = {
                    title: element.getAttribute('data-page-nav'),
                    anchor: `#${element.getAttribute('id')}`,
                    iconUrl: element.getAttribute('data-navigation-icon') || '',
                };
                arr.push(obj);
            }

            return arr;
        },

        detectSection() {
            if (!this.allNavigationItems) {
                return;
            }

            for (let i = 0; i < this.allNavigationItems.length; i++) {
                const tlDown = gsap.timeline({
                    scrollTrigger: {
                        trigger: this.allNavigationItems[i],
                        start: 'top center',
                        end: 'bottom 75%',
                        onEnter: ({ progress, direction, isActive }) => {
                            this.currentIndex = i;
                            this.handleTimer(i);
                        },
                        onLeave: () => {
                            if (i === this.allNavigationItems.length - 1) {
                                this.pastLastSection = true;
                            } else {
                                this.pastLastSection = false;
                            }
                        },
                    },
                });

                const tlUp = gsap.timeline({
                    scrollTrigger: {
                        trigger: this.allNavigationItems[i],
                        start: 'bottom center',
                        end: 'top 25%',
                        onEnterBack: ({ progress, direction, isActive }) => {
                            this.currentIndex = i;
                            this.handleTimer(i);
                            if (i === this.allNavigationItems.length - 1) {
                                this.pastLastSection = false;
                            }
                        },
                        onLeave: () => {
                            if (i === this.allNavigationItems.length - 1) {
                                this.pastLastSection = true;
                            } else {
                                this.pastLastSection = false;
                            }
                        },
                    },
                });
            }
        },

        handleMouseEnter(e) {
            const el = e.target;
            const frenchParent = e.target.parentNode.parentNode;
            const isActive = el.classList.contains('active');
            const isFrenchActive = frenchParent.classList.contains(
                'french-active-parent',
            );

            if (isActive || isFrenchActive) {
                return;
            }

            const siblings = el.parentNode.children;
            for (let i = 0; i < siblings.length; i++) {
                if (siblings[i].classList.contains('active')) {
                    // Set currentIndex to null to prevent active class
                    this.currentIndex = null;
                    // Remove active class from current active
                    siblings[i].classList.remove('active');
                }
            }
        },

        handleParentMouseEnter(e) {
            const el = e.target;
            const listItems = el.lastChild.children;
            const isFrenchActive = el.classList.contains(
                'french-active-parent',
            );

            if (isFrenchActive) {
                return;
            }

            el.classList.add('french-active-parent');
            for (let i = 0; i < listItems.length; i++) {
                listItems[i].classList.add('french-active-child');
            }
        },

        handleMouseLeave(e) {
            const el = e.target;
            const siblings = el.parentNode.children;

            let isActive = false;
            for (let i = 0; i < siblings.length; i++) {
                if (siblings[i].classList.contains('active')) {
                    // Set isActive to true if user has clicked on an nav item
                    isActive = true;
                }
            }
        },

        handleParentMouseLeave(e) {
            const el = e.target;
            const listItems = el.lastChild.children;

            el.classList.remove('french-active-parent');
            for (let i = 0; i < listItems.length; i++) {
                listItems[i].classList.remove('french-active-child');
            }
        },

        handleTimer() {
            if (this.activeTimer) {
                clearTimeout(this.activeTimer);
            }

            this.activeTimer = setTimeout(() => {
                this.currentIndex = null;
            }, 3000);
        },
    },
    beforeDestroy() {},
});
